import { GamepadRoundLeftIcon } from './GamepadRoundLeftIcon';

/**
 * author: Haley Halcyon
 * id 07D26BD5-0B09-4FAF-9710-DA1F19C40C39
 * name gamepad-round-left
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-round-left.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerRoundLeftIcon = GamepadRoundLeftIcon;
export default ControllerRoundLeftIcon